import { Endpoint } from '../endpoint';
import { CommissionGroupResponse, CommissionGroupId, CommissionGroupRequest } from '@business/entities/commission_group';

export function fetchCommissionGroups() {
  return Endpoint.get<CommissionGroupResponse[]>(`@gc/commission-group`);
}

export function fetchCommissionGroup(id: CommissionGroupId) {
  return Endpoint.get<CommissionGroupResponse>(`@gc/commission-group/company/${id}`);
}

export function createCommissionGroup(data: Partial<CommissionGroupRequest>) {
  return Endpoint.post<CommissionGroupResponse>(`@gc/commission-group/create`, { data });
}

export function updateCommissionGroup(id: CommissionGroupId, data: Partial<CommissionGroupRequest>) {
  return Endpoint.patch<CommissionGroupResponse>(`@gc/commission-group/${id}`, { data });
}

export function deleteCommissionGroup(id: CommissionGroupId) {
  return Endpoint.delete<void>(`@gc/commission-group/${id}`);
}
